import React from "react";
import _ from "lodash";
import {Table, Container, Header, Button, Icon} from "semantic-ui-react";
import CsvDownload from "react-json-to-csv";
import DeleteEntryModal from "./DeleteEntryModal";

//UI for how the student recordings will look
function AudioRecording(
    {
        studentData,
        pageName,
        CSVFile,
        assignmentNum,
        handleClearAssignmentData
    }
) {
    return (
        <>
            <DeleteEntryModal
                page={pageName}
                assignmentNum={assignmentNum}
                handleClearAssignmentData={handleClearAssignmentData}
            />
            <div style={{marginBottom: 10}}>
                <Header as='h1' textAlign='center'>
                    {pageName} Student Completion
                </Header>
                <Container>
                    {
                        studentData.length === 0 ?
                            <Header as='h1' textAlign='center'>No student has completed this assignment yet</Header>
                            :
                            <>
                                <CsvDownload data={CSVFile} filename={pageName + '_Data_Assignment_' + assignmentNum + '.csv'}/>

                                <Table celled>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell textAlign='center'>Email</Table.HeaderCell>
                                        <Table.HeaderCell textAlign='center'>Link</Table.HeaderCell>
                                        <Table.HeaderCell textAlign='center'>Date Submitted</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {
                                        _.times(studentData.length, (i) => (
                                            <>
                                                <Table.Row>
                                                    <Table.Cell>
                                                        {studentData[i].email}
                                                    </Table.Cell>
                                                    <Table.Cell>
                                                        <a href={studentData[i].url} target='_blank'>Link to Recording</a>
                                                    </Table.Cell>
                                                    <Table.Cell textAlign='right'>
                                                        {studentData[i].date}
                                                    </Table.Cell>
                                                </Table.Row>
                                            </>
                                        ))
                                    }
                                </Table.Body>
                            </Table>
                            </>
                    }

                </Container>
            </div>
        </>
    )
}

export default AudioRecording
